import { render, staticRenderFns } from "./VErrorMessages.vue?vue&type=template&id=130722e9"
import script from "./VErrorMessages.vue?vue&type=script&lang=js"
export * from "./VErrorMessages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports